import { Button, Typography } from "@mui/material";
import UISwipeableDrawer from "components/drawers/SwipeableDrawer";
import SupportCard from "components/wrapper_v2/SupportCard";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setConsent } from "redux/actions/Consent";
import {
  set_show_popup,
  set_show_zoom_popup,
} from "redux/actions/ScribeAcitons";
import {
  leftPanelReset,
  rightPanelReset,
} from "redux/reducers/EncounterResetSlice";

//Available 24/7 Button For the Top bar
const Available247 = () => {
  const { i18n } = useTranslation();

  const [isSupportDrawerOpen, setIsSupportDrawerOpen] = useState(false);
  const isRecording = useSelector((state) => state?.recognizer?.recording);
  const isPaused = useSelector((state) => state?.recognizer?.paused);
  const zoomCallOngoing = useSelector(
    (state) => state?.recognizer?.zoomCallOngoing
  );
  const reduxDispatch = useDispatch();

  return (
    <>
      {isSupportDrawerOpen && (
        <UISwipeableDrawer
          open={isSupportDrawerOpen}
          setOpen={setIsSupportDrawerOpen}
          appBar={false}
          width={"clamp(40vh,40%,60vw)"}
          jsx={
            <SupportCard
              key={isSupportDrawerOpen}
              handleClose={() => setIsSupportDrawerOpen(false)}
            />
          }
        />
      )}
      <Button
        sx={style.buttonStyle}
        variant="outlined"
        onClick={() => {
          if (isRecording || isPaused) {
            reduxDispatch(
              set_show_popup(true, () => {
                reduxDispatch(setConsent(false));
                reduxDispatch(leftPanelReset());
              })
            );
          } else if (zoomCallOngoing) {
            reduxDispatch(set_show_zoom_popup(true));
          } else {
            setIsSupportDrawerOpen(true);
          }
        }}
      >
        <Typography
          sx={{
            fontSize: "clamp(0.8vh, 0.8vw, 0.8vw)",
          }}
        >
          {/* {`${i18n.t("dashboard2.AVAILABLE")} 24/7`} */}
          {i18n.t("common.Help")}
        </Typography>
      </Button>
    </>
  );
};

const style = {
  buttonStyle: {
    padding: "0.3vw 0.5vw",
    color: "#fff",
    background:
      "linear-gradient(90deg, rgba(43, 44, 119, 0.5) 47.31%, rgba(188, 184, 184, 0.5) 129.24%)",
    textTransform: "none",
    borderRadius: "2vw",
  },
};

export default Available247;
